var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuplicate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1425:9826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 15.6666H15C15.1768 15.6666 15.3464 15.5964 15.4714 15.4714C15.5964 15.3464 15.6667 15.1768 15.6667 15V4.31665C15.6667 3.2602 15.247 2.24702 14.5 1.5C13.753 0.752984 12.7398 0.333313 11.6833 0.333313H3.66667C3.48986 0.333313 3.32029 0.403551 3.19526 0.528575C3.07024 0.653599 3 0.823169 3 0.99998V5.66665",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.333 0.386658V2.99999C12.333 3.1768 12.4032 3.34637 12.5283 3.4714C12.6533 3.59642 12.8229 3.66666 12.9997 3.66666H15.613",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.333008 11.6666C0.333008 12.1919 0.436471 12.7121 0.63749 13.1974C0.838508 13.6827 1.13315 14.1236 1.50458 14.4951C1.87601 14.8665 2.31697 15.1611 2.80227 15.3621C3.28758 15.5632 3.80772 15.6666 4.33301 15.6666C4.8583 15.6666 5.37844 15.5632 5.86374 15.3621C6.34904 15.1611 6.79 14.8665 7.16143 14.4951C7.53287 14.1236 7.82751 13.6827 8.02853 13.1974C8.22954 12.7121 8.33301 12.1919 8.33301 11.6666C8.33301 11.1413 8.22954 10.6212 8.02853 10.1359C7.82751 9.65059 7.53287 9.20963 7.16143 8.8382C6.79 8.46676 6.34904 8.17213 5.86374 7.97111C5.37844 7.77009 4.8583 7.66663 4.33301 7.66663C3.80772 7.66663 3.28758 7.77009 2.80227 7.97111C2.31697 8.17213 1.87601 8.46676 1.50458 8.8382C1.13315 9.20963 0.838508 9.65059 0.63749 10.1359C0.436471 10.6212 0.333008 11.1413 0.333008 11.6666V11.6666Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 11H5.66667",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.3333H5.66667",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1425:9826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.9bead2b6944ecc6545ecdebd25d7b496.svg";
export { ForwardRef as ReactComponent };